import { ITyre } from '@wyz/types';
import { IOffer, IPayloadAddItemsCart } from '~/purchase/types';

export const prepareAddToCartPayload = (
  tyre: ITyre,
  offers: Array<IOffer>,
  quantities: Array<number>,
): IPayloadAddItemsCart => {
  return {
    items: offers
      .map(({ supplier, offerMetadata }, offerIndex) => {
        return {
          quantity: quantities?.[offerIndex] ?? 0,
          supplier: {
            id: supplier.id,
            name: supplier.name,
            stock: offerMetadata.availableQuantity,
            type: supplier.supplierBehavior, // nameKey, id ?
            orderable: supplier.orderable,
          },
          tyre: {
            ean: tyre.ean,
            brand: tyre.brand.name,
            profile: tyre.profile.design1,
            cai: tyre.supplierCode,
            constructorReference: tyre.constructorReference,
            alternativeReference: tyre.alternativeReference,
            season: tyre.season.name,
            vehicleType: tyre.vehicleType.name,
            vehicleTypePublicKey: tyre.vehicleType.publicKey,
            dimension: tyre.dimension.fullSize,
            productTypePublicKey: tyre.productType.publicKey,
          },
          price: {
            bf: tyre.priceFrame?.price,
            currency: tyre.priceFrame.currencyIsoCode,
            unitPrice: offerMetadata.displayPrice,
            j0Price: offerMetadata.j0Price,
            ecotax: tyre.priceFrame.recyclingFee ?? undefined,
          },
          deliveryDate: offerMetadata.deliveryDate
            ? new Date(offerMetadata.deliveryDate)
            : undefined,
          isJ0Delivery: offerMetadata.isJ0,
          isBackOrder: offerMetadata.isBackOrder,
          offerType: offerMetadata.offerType,
          warehouseId: offerMetadata.warehouseId,
          extendedManufacturer: offerMetadata.extendedManufacturer,
        };
      })
      .filter((item) => item.quantity !== 0),
  };
};
